const Chevron = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M6 9.44 7.414 8 12 13.118 16.586 8 18 9.44 12 16 6 9.44z" fill="#000" />
    </svg>
)

export default Chevron;